import React, { useState } from 'react';
import DynamicForm from '../../../Dynamic/Components/DynamicForm/DynamicForm';
import OverlayLoading from '../../../../Components/OverlayLoading';
// @ts-ignore
import styles from './QuestionnaireForDoctor.module.scss';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

interface Props {
	wizardKey: string;
}

const QuestionnaireForDoctor: React.FC<Props> = ({ wizardKey }) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleOnSuccess = () => {
		setIsLoading(true);
		// @ts-ignore
		window.location.href = '/moje-pozadavky';
		setIsLoading(false);
	};

	return (
		<ScrollContainer>
			<div className={styles.wrapper}>
				<DynamicForm
					wizardKey={wizardKey}
					setIsLoading={setIsLoading}
					onSuccess={handleOnSuccess}
				/>
			</div>
			{isLoading && <OverlayLoading />}
		</ScrollContainer>
	);
};

export default QuestionnaireForDoctor;
